// extracted by mini-css-extract-plugin
module.exports = {"divider":"page-contact_divider__aWzi4"};